<template>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :show-close="false" width="1200px">
        <div slot="title" class="glsx_header">
            <div style="color: #000">近一年请休假</div>
            <div style="cursor: pointer" @click="closed"><i class="el-icon-close"></i></div>
        </div>
        <div class="search">
            <el-input v-model="searchVal" placeholder="搜索..." class="input-with-select" @keyup.enter.native="getData()">
                <el-button slot="append" style="padding: 0 20px" icon="el-icon-search" @click="getData"></el-button>
            </el-input>
            <!-- <el-button type="primary" style="margin-left:10px" @click="submit" icon="el-icon-check">确定</el-button> -->
        </div>
        <el-table v-loading="loading" :data="dataList" border :empty-text="loading ? ' ' : ''" stripe :style="{ width: '100%', 'min-height': loading ? '180px' : '80px' }">
            <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
            <el-table-column prop="actualUserDept" label="所在部门" align="center" width="120"></el-table-column>
            <el-table-column prop="flSubject" label="请假事由"></el-table-column>
            <el-table-column prop="vacateDay" label="请假时长" align="center" width="150">
                <template slot-scope="scope">
                    <div>
                        <span>{{ scope.row.vacateDay || 0 }}天</span>
                        <span v-if="scope.row.vacateHour">{{ scope.row.vacateHour || 0 }}小时</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="actualDay" label="实际请假时长" align="center" width="150">
                <template slot-scope="scope">
                    <div>
                        <span>{{ scope.row.actualDay || 0 }}天</span>
                        <span v-if="scope.row.vacateHour">{{ scope.row.actualHour || 0 }}小时</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="vacateStartDate" label="请假开始日期" align="center" width="160">
                <template slot-scope="scope">
                    <div>
                        <span>{{ setDate(scope.row.vacateStartDate) }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="vacateEndDate" label="请假结束日期" align="center" width="160">
                <template slot-scope="scope">
                    <div>
                        <span>{{ setDate(scope.row.vacateEndDate) }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="leaveType" label="请假类型" align="center" sortable width="100">
                <template slot-scope="scope">
                    <div>{{ setLeaveType(scope.row.leaveType) }}</div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination prev-text="上一页" next-text="下一页" :current-page="params.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {},
    data() {
        return {
            dialogVisible: false,
            params: {
                pageSize: 10,
                pageNum: 1,
                searchAndOr: ''
            },
            loading: false,
            multipleSelection: [],
            searchVal: '',
            dataList: [],
            total: 0,
            vo: null
        }
    },
    created() {
        // http://14.18.154.83:7001/apigw/dcontent/getListpageInfo/workflow.wfInstance.list_RvR4do.vue/
        this.$http({
            method: 'get',
            contentType: 'application/x-www-form-urlencoded',
            url: 'dcontent/getListpageInfo/ecykq.vacateRecord.list/'
        }).then((res) => {
            this.params.listPageId = res.body.listpage.id
        })
    },
    mounted() {},
    methods: {
        setDate(val) {
            let str = ''
            if (val && val.length > 18) {
                str = this.$moment(val).format('YYYY-MM-DD HH:mm')
            } else {
                str = val
            }
            return str
        },
        setLeaveType(type) {
            let str = ''
            if (this.vo.passenger.flLeaveTypeOptions) {
                this.vo.passenger.flLeaveTypeOptions.forEach((item) => {
                    if (item.value == type) {
                        str = item.text
                    }
                })
            }
            return str
        },
        init(urlsearch, vo) {
            // 初始化弹窗
            this.dialogVisible = true
            this.vo = vo
            this.params.urlsearch = urlsearch
            this.getData()
        },
        closed() {
            this.$emit('setDialog')
            this.dialogVisible = false
        },
        handleSizeChange(val) {
            this.params.pageSize = val
            this.params.pageNum = 1
            this.getData()
        },
        handleCurrentChange(val) {
            this.params.pageNum = val
            this.getData()
        },
        getData() {
            this.loading = true
            const formData = new FormData()
            formData.append('pageSize', this.params.pageSize)
            formData.append('pageNum', this.params.pageNum)
            formData.append('listPageId', this.params.listPageId)
            formData.append('orderBy', 'actualStartTime desc')
            if (this.params.urlsearch) formData.append('urlsearch', this.params.urlsearch)
            if (this.searchVal) {
                formData.append('searchAndOr', 'or')
                // formData.append('searchMap[actualUserDept]', this.searchVal)
                formData.append('searchMap[flSubject]', this.searchVal)
                // formData.append('searchMap[flCreator]', this.searchVal)
            } else {
                formData.append('searchAndOr', '')
            }
            this.$http({
                method: 'post',
                contentType: 'application/x-www-form-urlencoded',
                data: formData,
                url: 'ecykq/vacateRecord/listdata'
            }).then((res) => {
                this.loading = false
                this.dataList = res.body.pageInfo.list || []
                this.total = res.body.pageInfo.total
                // this.$message.success('搜索成功！')
            })
        },
        submit() {
            this.closed()
            this.$emit('setList', this.multipleSelection)
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        }
    }
}
</script>
<style lang='scss' scoped>
.glsx_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 20px;
    background: #f3f4f4;
}
/deep/.el-loading-mask {
    margin-top: 47px !important;
}
.pagination {
    display: flex;
    margin-top: 10px;
    justify-content: flex-end;
}
.search {
    display: flex;
    margin: 10px 0;
}
/deep/.el-input__inner {
    font-size: var(--portalFontSize13) !important;
}
</style>
